import { render, staticRenderFns } from "./CollapseResource.vue?vue&type=template&id=a758a324&scoped=true"
import script from "./CollapseResource.vue?vue&type=script&lang=js"
export * from "./CollapseResource.vue?vue&type=script&lang=js"
import style0 from "./CollapseResource.vue?vue&type=style&index=0&id=a758a324&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a758a324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a758a324')) {
      api.createRecord('a758a324', component.options)
    } else {
      api.reload('a758a324', component.options)
    }
    module.hot.accept("./CollapseResource.vue?vue&type=template&id=a758a324&scoped=true", function () {
      api.rerender('a758a324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/CollapseResource.vue"
export default component.exports